import { ContentHeaderButton } from "../../contentHeaderButton";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { IndorImages, getIndorImageSrc } from "../../../../features";
import { store } from "../../../../stateManagement/store";
import { setTableInfoWindowIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice";

const showTableInfoWindowButtonIconSrc = getIndorImageSrc(IndorImages.MessageInfo);

export default function ContentHeaderDevExtremeTableWidgets() {
    const { tableInfoWindowIsShown } = useAppSelector(state => state.contentHeader)

    function controlShowTableInfoWindowButton() {
        const tableInfoWindowIsShown = store.getState().contentHeader.tableInfoWindowIsShown
        store.dispatch(setTableInfoWindowIsShown(!tableInfoWindowIsShown))
    }

    const widgetsConfigArray = [
        {
            active: tableInfoWindowIsShown,
            name: "Информация о таблице",
            imageSrc: showTableInfoWindowButtonIconSrc,
            onClick: controlShowTableInfoWindowButton
        }
    ]

    return (
        <>
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick, loading } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            key={name}
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                            isLoading={loading}
                        />
                    )
                }
            })}
        </>
    )
}